/**
 * AutoMap analytics event names — no imports (safe during analytics module init).
 */

export const BUYER_EVENT_CATEGORIES = {
  PAGE_VIEW: "page_view",
  SEARCH: "search",
  FILTER: "filter",
  LISTING_ENGAGEMENT: "listing_engagement",
  DEALER_ENGAGEMENT: "dealer_engagement",
  QUIZ: "quiz",
  RECOMMENDATION: "recommendation",
  CHECKLIST: "checklist",
  COMPARE: "compare",
  SAVE: "save",
  CONTACT: "contact",
  LEAD: "lead",
  SEO: "seo",
  GUIDE: "guide",
  TRUST_SAFETY: "trust_safety",
  FAIR_PRICE: "fair_price",
  RISK: "risk",
  VERIFICATION: "verification",
  SELLER_INTAKE: "seller_intake",
  GEOLOCATION: "geolocation",
};

export const BUYER_ANALYTICS_EVENTS = {
  PAGE_VIEWED: "page_viewed",
  SEARCH_PERFORMED: "search_performed",
  SEARCH_RESULTS_VIEWED: "search_results_viewed",
  SEARCH_NO_RESULTS: "search_no_results",
  SEARCH_SORT_CHANGED: "search_sort_changed",
  SEARCH_PAGINATION_CLICKED: "search_pagination_clicked",
  SEARCH_RESULT_CARD_CLICKED: "search_result_card_clicked",
  SEARCH_FILTER_CHANGED: "search_filter_changed",
  VEHICLE_DETAIL_VIEWED: "vehicle_detail_viewed",
  VEHICLE_PHOTO_GALLERY_OPENED: "vehicle_photo_gallery_opened",
  VEHICLE_PHOTO_CHANGED: "vehicle_photo_changed",
  VEHICLE_FAIR_PRICE_VIEWED: "vehicle_fair_price_viewed",
  VEHICLE_RISK_PANEL_VIEWED: "vehicle_risk_panel_viewed",
  VEHICLE_CHECKLIST_OPENED: "vehicle_checklist_opened",
  VEHICLE_SAVED: "vehicle_saved",
  VEHICLE_UNSAVED: "vehicle_unsaved",
  BUYER_ACCOUNT_VIEWED: "buyer_account_viewed",
  BUYER_LIKES_VIEWED: "buyer_likes_viewed",
  PRIVACY_NOTIFICATIONS_VIEWED: "privacy_notifications_viewed",
  LEGAL_DOCUMENT_OPENED: "legal_document_opened",
  REQUIRED_CONSENT_ACCEPT_STARTED: "required_consent_accept_started",
  REQUIRED_CONSENT_ACCEPT_COMPLETED: "required_consent_accept_completed",
  CONSENT_WITHDRAW_STARTED: "consent_withdraw_started",
  CONSENT_WITHDRAW_COMPLETED: "consent_withdraw_completed",
  NOTIFICATION_PREFERENCE_CHANGED: "notification_preference_changed",
  PRIVACY_SUPPORT_OPENED: "privacy_support_opened",
  RETURN_TO_CHAT_CLICKED: "return_to_chat_clicked",
  CHAT_COMPLIANCE_LOADED: "chat_compliance_loaded",
  CHAT_COMPLIANCE_LOAD_FAILED: "chat_compliance_load_failed",
  CHAT_PRIVACY_SETTINGS_OPENED: "chat_privacy_settings_opened",
  CHAT_PROTECTED_ACTION_ATTEMPTED: "chat_protected_action_attempted",
  CHAT_PROTECTED_ACTION_BLOCKED: "chat_protected_action_blocked",
  CHAT_PROTECTED_ACTION_RESUMED: "chat_protected_action_resumed",
  CHAT_REQUIRED_REVIEW_SHOWN: "chat_required_review_shown",
  CHAT_LEAD_CREATED: "chat_lead_created",
  CHAT_LEAD_SNAPSHOT_CREATED: "chat_lead_snapshot_created",
  CHAT_LEAD_SNAPSHOT_FAILED: "chat_lead_snapshot_failed",
  CHAT_DEALER_SHARING_BLOCKED: "chat_dealer_sharing_blocked",
  BUYER_GUEST_MERGE_STARTED: "buyer_guest_merge_started",
  BUYER_GUEST_MERGE_COMPLETED: "buyer_guest_merge_completed",
  BUYER_GUEST_MERGE_FAILED: "buyer_guest_merge_failed",
  BUYER_PREFERENCES_VIEWED: "buyer_preferences_viewed",
  BUYER_FINANCING_PREFS_SAVED: "buyer_financing_prefs_saved",
  BUYER_QUIZ_INTENT_SAVED: "buyer_quiz_intent_saved",
  BUYER_PROFILE_MERGE_APPLIED: "buyer_profile_merge_applied",
  BUYER_PAYMENT_ESTIMATE_VIEWED: "buyer_payment_estimate_viewed",
  BUYER_PAYMENT_PREFERENCES_EDIT_CLICKED: "buyer_payment_preferences_edit_clicked",
  VEHICLE_DETAIL_PAYMENT_ESTIMATE_VIEWED: "vehicle_detail_payment_estimate_viewed",
  VEHICLE_COMPARE_ADDED: "vehicle_compare_added",
  VEHICLE_COMPARE_REMOVED: "vehicle_compare_removed",
  VEHICLE_COMPARE_OPENED: "vehicle_compare_opened",
  VEHICLE_COMPARE_CLEARED: "vehicle_compare_cleared",
  VEHICLE_COMPARE_DETAIL_CLICKED: "vehicle_compare_detail_clicked",
  DEALER_PROFILE_VIEWED: "dealer_profile_viewed",
  DEALER_DIRECTORY_VIEWED: "dealer_directory_viewed",
  DEALER_CONTACT_CLICKED: "dealer_contact_clicked",
  DEALER_WHATSAPP_CLICKED: "dealer_whatsapp_clicked",
  QUIZ_STARTED: "quiz_started",
  QUIZ_STEP_VIEWED: "quiz_step_viewed",
  QUIZ_STEP_COMPLETED: "quiz_step_completed",
  QUIZ_COMPLETED: "quiz_completed",
  QUIZ_ABANDONED: "quiz_abandoned",
  QUIZ_RESULTS_VIEWED: "quiz_results_viewed",
  QUIZ_LEAD_SUBMITTED: "quiz_lead_submitted",
  RECOMMENDATION_RESULTS_VIEWED: "recommendation_results_viewed",
  RECOMMENDATION_CARD_CLICKED: "recommendation_card_clicked",
  RECOMMENDATION_CONTACT_CLICKED: "recommendation_contact_clicked",
  BUYER_CHECKLIST_PAGE_VIEWED: "buyer_checklist_page_viewed",
  BUYER_CHECKLIST_ITEM_CHECKED: "buyer_checklist_item_checked",
  BUYER_CHECKLIST_COMPLETED: "buyer_checklist_completed",
  WHATSAPP_CONTACT_CLICKED: "whatsapp_contact_clicked",
  LEAD_FORM_OPENED: "lead_form_opened",
  LEAD_FORM_SUBMITTED: "lead_form_submitted",
  LEAD_CREATED: "lead_created",
  CONTACT_MODAL_OPENED: "contact_modal_opened",
  SEO_PAGE_VIEWED: "seo_page_viewed",
  SEO_INVENTORY_CARD_CLICKED: "seo_inventory_card_clicked",
  GUIDE_PAGE_VIEWED: "guide_page_viewed",
  GUIDE_CTA_CLICKED: "guide_cta_clicked",
};

export const FAIR_PRICE_ANALYTICS_EVENTS = {
  BADGE_VIEWED: "fair_price_badge_viewed",
  BADGE_CLICKED: "fair_price_badge_clicked",
  SECTION_VIEWED: "fair_price_section_viewed",
  EXPLANATION_OPENED: "fair_price_explanation_opened",
  COMPARE_SIMILAR_CLICKED: "fair_price_compare_similar_clicked",
  FILTER_APPLIED: "fair_price_filter_applied",
  TOOLTIP_OPENED: "fair_price_tooltip_opened",
  DETAIL_VIEWED: "fair_price_detail_viewed",
};

export const RISK_ANALYTICS_EVENTS = {
  BADGE_VIEWED: "vehicle_risk_badge_viewed",
  BADGE_CLICKED: "vehicle_risk_badge_clicked",
  SECTION_VIEWED: "vehicle_risk_section_viewed",
  FLAG_VIEWED: "vehicle_risk_flag_viewed",
  QUESTION_CLICKED: "vehicle_risk_question_clicked",
  COMPARE_SIMILAR_CLICKED: "vehicle_risk_compare_similar_clicked",
  FILTER_APPLIED: "vehicle_risk_filter_applied",
  TOOLTIP_OPENED: "vehicle_risk_tooltip_opened",
};

export const CHECKLIST_ANALYTICS_EVENTS = {
  PREVIEW_VIEWED: "buyer_checklist_preview_viewed",
  ITEM_CLICKED: "buyer_checklist_item_clicked",
  FULL_OPENED: "buyer_checklist_full_opened",
  ITEM_CHECKED: "buyer_checklist_item_checked",
  ITEM_UNCHECKED: "buyer_checklist_item_unchecked",
  COMPARE_SIMILAR_CLICKED: "buyer_checklist_compare_similar_clicked",
  GUIDE_CLICKED: "buyer_checklist_guide_clicked",
  CONTACT_REMINDER_VIEWED: "buyer_checklist_contact_reminder_viewed",
};

export const DEALER_CONTACT_ANALYTICS_EVENTS = {
  BADGE_VIEWED: "dealer_badge_viewed",
  PROFILE_CLICKED: "dealer_profile_clicked",
  CONTACT_CTA_CLICKED: "vehicle_contact_cta_clicked",
  WHATSAPP_CLICKED: "vehicle_whatsapp_clicked",
  PHONE_CLICKED: "vehicle_phone_clicked",
  LEAD_CREATED: "vehicle_lead_created",
  LEAD_CREATE_FAILED: "vehicle_lead_create_failed",
  CONTACT_DISABLED_CLICKED: "vehicle_contact_disabled_clicked",
  WHATSAPP_OPENED: "vehicle_contact_whatsapp_opened",
};

export const RECOMMENDATION_ANALYTICS_EVENTS = {
  SECTION_VIEWED: "vehicle_recommendation_section_viewed",
  CARD_CLICKED: "vehicle_recommendation_card_clicked",
  SEARCH_CTA_CLICKED: "vehicle_recommendation_search_cta_clicked",
  SAME_DEALER_CTA_CLICKED: "vehicle_same_dealer_cta_clicked",
  UNAVAILABLE_VIEWED: "vehicle_unavailable_recommendations_viewed",
};

export const LEAD_CAPTURE_ANALYTICS_EVENTS = {
  MODAL_OPENED: "lead_modal_opened",
  FORM_STARTED: "lead_form_started",
  FORM_FIELD_ERROR: "lead_form_field_error",
  FORM_SUBMITTED: "lead_form_submitted",
  SUBMISSION_SUCCEEDED: "lead_submission_succeeded",
  SUBMISSION_FAILED: "lead_submission_failed",
  SUBMISSION_DUPLICATE: "lead_submission_duplicate",
  SUBMISSION_RATE_LIMITED: "lead_submission_rate_limited",
  SUBMISSION_SPAM_REJECTED: "lead_submission_spam_rejected",
  MODAL_CLOSED: "lead_modal_closed",
  RETRY_CLICKED: "lead_retry_clicked",
};

/** AutoMapa WhatsApp widget funnel events (M8 admin/monitoring). */
export const AUTOMAP_WHATSAPP_WIDGET_ANALYTICS_EVENTS = Object.freeze({
  WIDGET_OPENED: "widget_opened",
  WIDGET_CLOSED: "widget_closed",
  VEHICLE_CONTEXT_ATTACHED: "vehicle_context_attached",
  INTAKE_STARTED: "intake_started",
  INTAKE_STEP_COMPLETED: "intake_step_completed",
  INTAKE_COMPLETED: "intake_completed",
  LEAD_SUBMIT_STARTED: "lead_submit_started",
  LEAD_SUBMIT_SUCCEEDED: "lead_submit_succeeded",
  LEAD_SUBMIT_FAILED: "lead_submit_failed",
  BROKER_SUBMIT_STARTED: "broker_submit_started",
  BROKER_SUBMIT_SUCCEEDED: "broker_submit_succeeded",
  BROKER_SUBMIT_FAILED: "broker_submit_failed",
  CONTINUE_WHATSAPP_CLICKED: "continue_whatsapp_clicked",
  STATUS_VIEWED: "status_viewed",
  STATUS_REFRESHED: "status_refreshed",
  DRAFT_RESTORED: "draft_restored",
  DRAFT_CLEARED: "draft_cleared",
  CHAT_THREAD_CREATED: "chat_thread_created",
  CHAT_THREAD_RESUMED: "chat_thread_resumed",
  CHAT_MESSAGE_CREATED: "chat_message_created",
  CHAT_MESSAGE_FAILED: "chat_message_failed",
  WHATSAPP_MESSAGE_RECEIVED: "whatsapp_message_received",
  WHATSAPP_MESSAGE_MATCHED_TO_THREAD: "whatsapp_message_matched_to_thread",
  WHATSAPP_MESSAGE_UNMATCHED: "whatsapp_message_unmatched",
  WHATSAPP_MESSAGE_STATUS_UPDATED: "whatsapp_message_status_updated",
  BOT_INTAKE_STARTED: "bot_intake_started",
  BOT_FIELD_REQUESTED: "bot_field_requested",
  BOT_FIELD_CAPTURED: "bot_field_captured",
  BOT_PARSE_FAILED: "bot_parse_failed",
  BOT_REVIEW_READY: "bot_review_ready",
  BOT_SUBMISSION_TRIGGERED: "bot_submission_triggered",
  BOT_SUBMISSION_SUCCEEDED: "bot_submission_succeeded",
  BOT_SUBMISSION_FAILED: "bot_submission_failed",
  BOT_FALLBACK_TO_FORM: "bot_fallback_to_form",
  /** M12 funnel / rollout events */
  WIDGET_VIEWED: "automapa_whatsapp_widget_viewed",
  CONSENT_ACCEPTED: "automapa_whatsapp_consent_accepted",
  INTAKE_SUBMITTED: "automapa_whatsapp_intake_submitted",
  LEAD_CREATED: "automapa_whatsapp_lead_created",
  BROKER_SUBMITTED: "automapa_whatsapp_broker_submitted",
  BOT_STARTED: "automapa_whatsapp_bot_started",
  BOT_COMPLETED: "automapa_whatsapp_bot_completed",
  MESSAGE_SENT: "automapa_whatsapp_message_sent",
  MESSAGE_RECEIVED: "automapa_whatsapp_message_received",
  THREAD_CREATED: "automapa_whatsapp_thread_created",
  ERROR: "automapa_whatsapp_error",
  WIDGET_FALLBACK_WA_ME: "automapa_whatsapp_widget_fallback_wa_me",
  FEATURE_GATED: "automapa_whatsapp_feature_gated",
});

export const SELLER_INTAKE_ANALYTICS_EVENTS = {
  PAGE_VIEWED: "seller_intake_page_viewed",
  PRIMARY_CTA_CLICKED: "seller_intake_primary_cta_clicked",
  SECONDARY_CTA_CLICKED: "seller_intake_secondary_cta_clicked",
  FORM_STARTED: "seller_intake_form_started",
  FIELD_CHANGED: "seller_intake_field_changed",
  VALIDATION_ERROR: "seller_intake_validation_error",
  SUBMIT_ATTEMPTED: "seller_intake_submit_attempted",
  SUBMIT_SUCCEEDED: "seller_intake_submit_succeeded",
  SUBMIT_FAILED: "seller_intake_submit_failed",
  DUPLICATE_DETECTED: "seller_intake_duplicate_detected",
  SPAM_REJECTED: "seller_intake_spam_rejected",
  RATE_LIMITED: "seller_intake_rate_limited",
  RESET_CLICKED: "seller_intake_reset_clicked",
  FORM_ABANDONED: "seller_intake_form_abandoned",
  GEOLOCATION_REQUESTED: "geolocation_requested",
  GEOLOCATION_GRANTED: "geolocation_granted",
  GEOLOCATION_DENIED: "geolocation_denied",
  GEOLOCATION_UNAVAILABLE: "geolocation_unavailable",
};
